import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import {
  GetQQAgentInvocationsParams,
  GetQQAgentInvocationsResponse,
} from 'types/agents/QuickQuoteAgent';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

// Fetches quick quote agent invocations and associated task invocations
export async function getQQAgentInvocations(
  data: GetQQAgentInvocationsParams
): Promise<Result<GetQQAgentInvocationsResponse, ApiError>> {
  try {
    const response = await axios.get<GetQQAgentInvocationsResponse>(
      `/agent/quick-quote/invocations/thread/${data.threadId}`
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getQQAgentInvocations' });

    if (!isAxiosError(error)) {
      return err({
        message: 'Error retrieving Quick Quote Agent data for this email.',
      });
    }

    if (error && isAxiosError(error) && error.response?.status === 401) {
      throw error;
    }

    if (error && error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message:
        error.response?.data?.message ||
        'Error retrieving Quick Quote Agent data for this email.',
    });
  }
}
